import { getDateFrom } from '../functions/format_date'

export default {
  data: () => ({
    filter: {
      projects: [],
      users: [],
      unitManagers: [],
      projectStatus: ''

    },
    timeParts: [
      {
        name: 'Yes',
        value: true,
        number: 1
      },
      {
        name: 'No',
        value: false,
        number: 0
      }
    ],
    projects: [],
    users: [],
    unitManagers: []
  }),
  computed: {
    __users () {
      let arr = []
      this.filter.users.map(user => {
        arr.push(user.jira_user_name)
      })
      return arr
    },
    __projectIds () {
      let arr = []
      this.filter.projects.map(project => {
        arr.push(project.id)
      })
      return arr
    },
    __projects () {
      let arr = []
      this.filter.projects.map(project => {
        arr.push(project.key)
      })
      return arr
    },
    __unitManagers () {
      let arr = []
      this.filter.unitManagers.map(manager => {
        arr.push(manager.jira_user_name)
      })
      return arr
    },
    __unitManagerIds () {
      let arr = []
      this.filter.unitManagers.map(manager => {
        arr.push(manager.id)
      })
      return arr
    }
  },
  methods: {
    __resetFilter (callback) {
      this.filter.users = []
      this.filter.projects = []
      this.filter.unitManagers = []
      this.filter.projectStatus = ''
      if (callback) {
        callback()
      }
    },
    __getDate (date, target) {
      let result = getDateFrom(date, target)
      if (target === 'from') {
        this.form.date_from = result
      } else {
        this.form.date_to = result
      }
    },
    __getProjectName (id) {
      const project = this.projects.find(item => item.id === id)
      if (project) {
        return project.name
      }
      return 'Project not specified'
    },
    __getUser (id) {
      const user = this.users.find(item => item.id === id)
      if (user) {
        return user
      }
      return 'User not found'
    },
    __getUserName (id) {
      const user = this.users.find(item => item.id === id)
      if (user) {
        return user.name
      }
      return 'User not found'
    },
    __getUserPosition (id) {
      const user = this.users.find(item => item.id === id)
      if (user) {
        return user.position
      }
      return 'User not found'
    },
    __getJiraUserName (id) {
      const user = this.users.find(item => item.id === id)
      if (user) {
        return user.jira_user_name
      }
      return 'User not found'
    },
    __getTimePartsText (value) {
      const text = this.timeParts.find(item => item.number === Number(value))
      return text.name
    }
  }
}
